<template>
  <!-- 修改SN/IMEI信息 -->
  <div class="cus-modal">
    <OmsForm :form-config="formConfig" />
    <OmsButton :btn-config="btnConfig" class="modal-footer" />
  </div>
</template>
<script>
export default {
  props: {
    componentData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      formConfig: {
        formValue: {
          originalSn: '',
          sn: ''
        },
        formData: [
          {
            style: 'input', // 输入框类型
            label: t('原SN/IMSI信息'),
            value: 'originalSn', // 输入框的值
            disabled: true,
            width: '24' // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
          },
          {
            style: 'input', // 输入框类型
            label: t('新SN/IMSI信息'),
            value: 'sn', // 输入框的值
            width: '24' // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
          },
        ]
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            type: '', // 按钮类型
            text: t('取消'), // 取消
            size: 'small', // 按钮大小
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            } // 按钮点击事件
          },
          {
            type: 'primary', // 按钮类型
            text: t('确定'), // 确定
            size: 'small', // 按钮大小
            btnclick: () => {
              this.confirm();
            } // 按钮点击事件
          }
        ]
      }
    };
  },
  watch: {
    'componentData.row.SG_C_PRO_SN_ECODE': {
      handler(v) {
        if (v) {
          this.formConfig.formValue.originalSn = v
        }
      },
      immediate: true
    }
  },
  methods: {
    confirm() {
      if (this.formConfig.formValue.sn == '') {
        return $fcError(t('请输入SN/IMEI信息'))
      }
      $fcWarn({
        className: 'ark-dialog',
        title: t('确认'),
        content: t('是否确认更新IMEI信息，更新后会重新进行延保信息！'),
        okText: t('是'),
        cancelText: t('否'),
        mask: true,
        showCancel: true,
        onOk: () => {
          let params = {
            id: this.componentData.row.ID,
            ...this.formConfig.formValue
          }
          this.service.common.publicUrlParams('/api/cs/oc/oms/v1/sn/updateSnPro', params).then(res => {
            if (res.data.code == 0) {
              this.$Message.success(res.data.message)
              const sn = this.$parent.$parent.$parent.queryTab('OC_B_ORDER_SN')
              this.$parent.$parent.$parent.labelClick(sn)
              this.$parent.$parent.closeConfirm();
            }
          })
        }
      })
    }
  }
};

</script>
